import { render, staticRenderFns } from "./BaseInputCheckbox.vue?vue&type=template&id=3008745c&scoped=true&"
import script from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./BaseInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputCheckbox.vue?vue&type=style&index=0&id=3008745c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008745c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3008745c')) {
      api.createRecord('3008745c', component.options)
    } else {
      api.reload('3008745c', component.options)
    }
    module.hot.accept("./BaseInputCheckbox.vue?vue&type=template&id=3008745c&scoped=true&", function () {
      api.rerender('3008745c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputCheckbox.vue"
export default component.exports